module.exports = __webpack_public_path__ + "img/23.20404923.jpg";